import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  mainDialog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: theme.spacing(50),
      width: theme.spacing(50),
    },
  },
  dialogContent: {
    overflow: 'visible',
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  actions: {},
  formSubmit: {
    marginTop: theme.spacing(-3),
  },
}));
